import { RootState } from "../Store";

export const SELECT_APPLICATIONS_DATA_TO_BANK = (state: RootState) =>
  state.applicationDataToBank.APPLICATION_DATA_TO_BANK;

export const SELECT_APPLICATIONS_DATA_TO_BANK_ACCOUNTING_BALANCE = (
  state: RootState
) =>
  state.applicationDataToBank.APPLICATION_DATA_TO_BANK?.balance_application
    ?.accountingBalance;

export const SELECT_APPLICATIONS_DATA_TO_BANK_BALANCE = (state: RootState) =>
  state.applicationDataToBank.APPLICATION_DATA_TO_BANK?.balance_application;

export const SELECT_APPLICATIONS_DATA_TO_BANK_NO_DOCUMENTS = (
  state: RootState
) => {
  const financeDocument =
    state.applicationDataToBank.APPLICATION_DATA_TO_BANK?.documents?.financeDocument.documents.filter(
      (doc) => doc.document === null
    );

  const pasportDocument =
    state.applicationDataToBank.APPLICATION_DATA_TO_BANK?.documents?.pasportDocument.documents.filter(
      (doc) => doc.document === null
    );

  return Boolean(financeDocument?.length || pasportDocument?.length);
};
